module.exports = __webpack_public_path__ + "static/media/viewActivity.899edfc7.png";